interface FinanceCompanyConfig {
  financeCompanyId: number;
  name: string;
  logo: string;
  lowestApr: number;
}

const financeCompanies = [
  {
    financeCompanyId: 50,
    name: "Alphera",
    logo: "alphera-logo.png",
    lowestApr: 9.9
  },
  {
    financeCompanyId: 63,
    name: "BNP Paribas",
    logo: "bnp-logo.svg",
    lowestApr: 12.9
  },
  {
    financeCompanyId: 21,
    name: "Close Finance",
    logo: "close-finance-logo.svg",
    lowestApr: 11.9
  },
  {
    financeCompanyId: 70,
    name: "Close Brothers",
    logo: "close-brothers-logo.svg",
    lowestApr: 11.9
  },
  {
    financeCompanyId: 22,
    name: "Moneyway",
    logo: "moneyway-logo.png",
    lowestApr: 17.8
  },
  {
    financeCompanyId: 46,
    name: "Moneway (Prime)",
    logo: "moneyway-logo.png",
    lowestApr: 17.8
  },
  {
    financeCompanyId: 67,
    name: "Motonovo",
    logo: "motonovo-logo.png",
    lowestApr: 11.9
  },
  {
    financeCompanyId: 16,
    name: "MotoNovo Finance",
    logo: "motonovo-logo.png",
    lowestApr: 11.9
  },
  {
    financeCompanyId: 9,
    name: "Moneybarn",
    logo: "moneybarn-logo.webp",
    lowestApr: 18.5
  },
  {
    financeCompanyId: 44,
    name: "Ratesetter",
    logo: null
  },
  {
    financeCompanyId: 48,
    name: "Blue Motor Finance",
    logo: "bluemotor-logo.png"
  },
  {
    financeCompanyId: 68,
    name: "Lendable",
    logo: "lendable-logo.png",
    lowestApr: 14.8
  },
  {
    financeCompanyId: 69,
    name: "Metro",
    logo: null
  },
  {
    financeCompanyId: 66,
    name: "V12 Finance",
    logo: "v12-retail-logo.png",
    lowestApr: 14.9
  },
  {
    financeCompanyId: 65,
    name: "Aldermore",
    logo: "aldermore-logo.svg"
  },
  {
    financeCompanyId: 39,
    name: "Startline Finance",
    logo: "startline-logo.svg",
    lowestApr: 21.8
  },
  {
    financeCompanyId: 58,
    name: "Oodle",
    logo: "oodle-logo.png",
    lowestApr: 13.1
  },
  {
    financeCompanyId: 64,
    name: "Oodle (Prime)",
    logo: "oodle-logo.png",
    lowestApr: 13.1
  },
  {
    financeCompanyId: 29,
    name: "Billing Finance",
    logo: "billing-logo.png",
    lowestApr: 23.9
  },
  {
    financeCompanyId: 8,
    name: "Advantage Finance",
    logo: "advantage-logo.svg",
    lowestApr: 18.99
  },
  {
    financeCompanyId: 62,
    name: "Mann Island Finance",
    logo: null
  },
  {
    financeCompanyId: 53,
    name: "Specialist Motor Finance",
    logo: "specialist-finance-logo.png"
  },
  {
    financeCompanyId: 49,
    name: "CarFinance 247",
    logo: "CarFinance247_logo_purple.svg",
    lowestApr: 8.9
  },
  {
    financeCompanyId: 71,
    name: "Automoney",
    logo: "automoney-logo.jpeg",
    lowestApr: 20.1
  },
  {
    financeCompanyId: 72,
    name: "Tandem",
    logo: "tandem-logo.svg",
    lowestApr: 16.9
  },
  {
    financeCompanyId: 73,
    name: "Zopa",
    logo: "zopa-logo.svg",
    lowestApr: 13.9
  },
  {
    financeCompanyId: 74,
    name: "Credit Agricole",
    logo: "credit-agricole-logo.svg",
    lowestApr: 9.9
  },
  {
    financeCompanyId: 75,
    name: "Northridge Finance",
    logo: "northridge-logo.png",
    lowestApr: 9.9
  },
  {
    financeCompanyId: 76,
    name: "Camco Finance",
    logo: "camco-finance-logo.png"
  },
  {
  financeCompanyId: 78,
  name: "Volkswagen Financial Services",
  logo: "volkswagen-financial-services-logo.png"
  },
  {
    financeCompanyId: 79,
    name: "JBR Capital",
    logo: "jbr-capital-logo.png"
  },
  {
    financeCompanyId: 80,
    name: "Marshmallow Finance",
    logo: "marshmallow-logo.png"
  },  
  {
    financeCompanyId: 81,
    name: "GoCarCredit",
    logo: "goCarCredit-logo.png"
  }

] as FinanceCompanyConfig[]

export {
  FinanceCompanyConfig,
  financeCompanies as FinanceCompanies
}
